module.exports = __webpack_public_path__ + "img/icons8-mercedes-benz.195c7297.svg";